import { Scale } from 'lucide-react';

/**
 * Bandeau légal affiché sur la page conformité
 * Références au décret, CASF, et mention contrôle administratif
 */
export const ConformiteLegalBanner = () => {
  return (
    <div className="rounded-[14px] border border-[hsl(var(--app-border-subtle))] bg-[hsl(var(--app-surface-muted))] px-3.5 py-2.5">
      <div className="flex items-start gap-2.5">
        <Scale className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[hsl(var(--app-text-muted))]" />
        <div className="min-w-0">
          <p className="text-[12px] leading-5 text-[hsl(var(--app-text-muted))]">
            Base légale : Loi n°2024-317 · Décret n°2026-324 · Article L.133-6 du CASF. Ce rapport constitue une preuve de vérification pour un contrôle administratif.
          </p>
        </div>
      </div>
    </div>
  );
};
